import * as React from 'react';
import Recipe from '../models/Recipe';
import ReactHtmlParser from 'react-html-parser';

interface RecipeCardProps {
  recipe: Recipe;
}
const RecipeCard: React.SFC<RecipeCardProps> = props => {
  return (
    <div className="recipe">
      <p className="title">{props.recipe.title}</p>
      <div className="time">
        <div className="total">
          <p>TOTAL TIME</p>
          <p className="">{props.recipe.totalTime} MIN</p>
        </div>
        <div className="prep">
          <p>PREP TIME</p>
          <p className="">{props.recipe.prepTime} MIN</p>
        </div>
      </div>
      <div className="description">{ReactHtmlParser(props.recipe.description)}</div>
      <div className="ingredients titled-section">
        <p>Ingredients</p>
        {ReactHtmlParser(props.recipe.ingredients)}
      </div>
      <div className="instructions titled-section">
        <p>Instructions</p>
        {ReactHtmlParser(props.recipe.instructions)}
      </div>
      <div className="reference titled-section">
        <p>Reference</p>
        {ReactHtmlParser(props.recipe.reference)}
      </div>
    </div>
  );
};

export default RecipeCard;
